import actionTypes from '../constants/action-types';
import helpers from '../helpers';

const setGlobalHTMLAndAffectHistory = (globalId, html) =>
  helpers.globalActionExtender({
    type: actionTypes.SET_GLOBAL_HTML_AND_AFFECT_HISTORY,
    payload: {
      globalId,
      html,
    },
  });

export default setGlobalHTMLAndAffectHistory;
